import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {MainScene as Scene} from './Template/MainScene'
import {Store} from '@learningblocks/protocol-redux';
import {Utilities} from '@learningblocks/exp-constants';

const {
  getAllDataFromAirtable,
  getGlossaryListWithAirtable,
  getIndividualGlossaryItem,
  getIndividialDataFromAirtable,
} = Utilities;
import {GlossaryProvider} from '@learningblocks/storybook-components';
import {
  HighlightProvider,
  calculateTooltipPosition,
  Log
} from '@learningblocks/shared-components';
import './App.scss';
import '@learningblocks/protocol-constants/lib/Styles/_styles.scss';

import {CATEGORY_LIST, API_DETAILS} from './Constants';
import { v4 as uuidv4 } from 'uuid';
import {initDatadogSimulations} from "@labxchange/util-datadog";
import {default as i18n} from '@learningblocks/shared-components/lib/i18n';
import {UsersnapProvider, loadUsersnapSimulation} from "@labxchange/util-usersnap";

class App extends Component {
  constructor (props) {
    super(props);
    initDatadogSimulations("photosynthesis");
  }

/**
   * Get the entire glossary list for glossary
   */
 getFullGlossaryList = () => {
  return getGlossaryListWithAirtable(
    getAllDataFromAirtable,
    API_DETAILS.URL,
    API_DETAILS.KEY,
    API_DETAILS.ID
  );
};

/**
 * Get individual glossary item
 */
getIndividualGlossaryItem = () =>
  getIndividualGlossaryItem(
    getIndividialDataFromAirtable,
    API_DETAILS.URL,
    API_DETAILS.KEY
  );

  render() {
    return (
      <div className='page-content wrapper'>
        <UsersnapProvider
          onLoadCallback={(event, api)=>loadUsersnapSimulation(event, api, i18n.language)}
        >
          <GlossaryProvider.Component
            categories={CATEGORY_LIST}
            fetchGlossaryList={this.getFullGlossaryList()}
            fetchGlossaryItem={this.getIndividualGlossaryItem()}>
            <HighlightProvider.Component
              calculateTooltipPosition={calculateTooltipPosition}>
              <Scene fetchGlossaryItem={this.getIndividualGlossaryItem()}/>
            </HighlightProvider.Component>
          </GlossaryProvider.Component>
        </UsersnapProvider>
      </div>
    );
  }
}

export default Store.getState();

window.React = React

ReactDOM.render(
  <Provider store={Store}>
      <Log 
        sim_id={1}
        sim_name={'Photosynthesis and Cellular Respiration'}
        sim_session_id={uuidv4()}
      >
        <App />
      </Log>
  </Provider>,
  document.getElementById('container')
);
